"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var FriendlySlugGenerator_1 = __importDefault(require("@CommonFrontendBackend/Utils/FriendlySlugGenerator"));
var ProjectLinkRetriever = (function () {
    function ProjectLinkRetriever(di, account, $location, usingFeature, genericHost, primaryDomain) {
        var _this = this;
        this.di = di;
        this.account = account;
        this.$location = $location;
        this.usingFeature = usingFeature;
        this.genericHost = genericHost;
        this.primaryDomain = primaryDomain;
        this.getUrlForLink = function (link) { return _this.getLink(link); };
        this.getUrl = function (project) {
            var link = _this.getDefaultLink(project);
            return _this.getLink(link, null, (0, FriendlySlugGenerator_1.default)(project.name));
        };
        this.getPdfUrlForLink = function (link) {
            _this.validateLink(link);
            var host = _this.getHost();
            return (link = _this.makeLink(host, link.secret, null, ["pdf"]));
        };
        this.getPdfUrlForProject = function (project) {
            var link = _this.getDefaultLink(project);
            return _this.getPdfUrlForLink(link);
        };
        this.getAllUrlsForProject = function (project) {
            var link = _this.getDefaultLink(project);
            return _this.getAllUrlsForLink(link, (0, FriendlySlugGenerator_1.default)(project.name));
        };
        this.getAllUrlsForLink = function (link, friendly) {
            var urls = {
                primaryDomain: _this.getLink(link, _this.genericHost, friendly),
            };
            if (_this.hasCustomDomain()) {
                urls.customDomain = _this.getLink(link, _this.account.customDomain, friendly);
            }
            if (_this.hasSubdomain()) {
                urls.subdomain = _this.getLink(link, _this.getSubdomainHost(), friendly);
            }
            return urls;
        };
        this.getUrlForSecret = function (secret, usePrimaryDomain, isTemplate) {
            if (usePrimaryDomain == null) {
                usePrimaryDomain = false;
            }
            if (isTemplate == null) {
                isTemplate = false;
            }
            if ((secret != null ? secret.length : undefined) === 0) {
                throw new Error("Trying to generate URL for empty or null secret");
            }
            var host = _this.getHost(usePrimaryDomain, isTemplate);
            return _this.makeLink(host, secret, null);
        };
        this.getOneTimeTokenUrl = function (id, hash) {
            var apiBaseUrl = _this.di.get("apiBaseUrl");
            return "".concat(apiBaseUrl, "/projects/").concat(id, "/oneTimeToken/").concat(hash);
        };
        this.getLink = function (link, host, friendly) {
            _this.validateLink(link);
            if (!(host != null ? host.length : undefined)) {
                host = _this.getHost();
            }
            return (link = _this.makeLink(host, link.secret, friendly));
        };
        this.getHost = function (usePrimaryDomain, isTemplate) {
            if (usePrimaryDomain === void 0) { usePrimaryDomain = false; }
            if (usePrimaryDomain) {
                return _this.genericHost;
            }
            else if (isTemplate) {
                return "templates.".concat(_this.primaryDomain);
            }
            else if (_this.hasCustomDomain()) {
                return _this.account.customDomain;
            }
            else if (_this.hasSubdomain()) {
                return _this.getSubdomainHost();
            }
            else {
                return _this.genericHost;
            }
        };
        this.hasSubdomain = function () { return _this.usingFeature(FeatureFlag_1.default.Subdomain) && _this.account.customSubdomain; };
        this.hasCustomDomain = function () {
            return _this.usingFeature(FeatureFlag_1.default.Domain) &&
                (_this.account.customDomain != null ? _this.account.customDomain.length : undefined);
        };
        this.getSubdomainHost = function () { return "".concat(_this.account.customSubdomain, ".").concat(_this.primaryDomain); };
        this.getProtocol = function (host) {
            var isCustomDomain = _this.account.customDomain && _this.account.customDomain === host;
            var isLegacy = _this.usingFeature(FeatureFlag_1.default.LegacyCustomDomain);
            var legacyHasUpdatedDns = _this.account.settings != null ? _this.account.settings.customDomainHasUpdatedDns : undefined;
            if (_this.usingFeature(FeatureFlag_1.default.Domain) && isCustomDomain && isLegacy && !legacyHasUpdatedDns) {
                return "http";
            }
            else {
                return _this.$location.protocol();
            }
        };
        this.makeLink = function (host, secret, friendly, segments) {
            var e_1, _a;
            if (segments === void 0) { segments = []; }
            var suffix;
            var segmentStr = "";
            try {
                for (var _b = __values(Array.from(segments)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var segment = _c.value;
                    segmentStr += segment + "/";
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if ((friendly != null ? friendly.length : undefined) > 0) {
                suffix = "".concat(friendly, "-").concat(secret);
            }
            else {
                suffix = secret;
            }
            var link = _this.getProtocol(host) + "://" + host + "/" + segmentStr + suffix;
            return link;
        };
        this.getDefaultLink = function (project) {
            if (project == null || project.links.length === 0) {
                throw new Error("Trying to generate url for a project with no links.");
            }
            else {
                return project.links[0];
            }
        };
        this.validateLink = function (link) {
            if (link == null) {
                throw new Error("Trying to generate url for a null link object.");
            }
            if (link.secret == null || link.secret === "") {
                throw new Error("Trying to generate url for a null or empty link secret.");
            }
        };
    }
    return ProjectLinkRetriever;
}());
exports.default = ProjectLinkRetriever;
